module.exports = __webpack_public_path__ + "static/img/crs-spotlight-context-matters.52734df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/crs-spotlight-context-matters.png
// module id = NbOK
// module chunks = 0